export enum HgLocalStorageKey {
  VISITED_LISTING_IDS = 'v_l_i',
  CONTACT_FORM_CONTENT_SNAPSHOT = 'contactFormContentSnapshot',
  MORTGAGE_MARKETPLACE_RATES = 'hgHymMortgages',
  FAVOURITE_LISTINGS = 'favouriteListings',
  LAST_SEARCH_MODELS = 'lastSearches',
  SEARCH_ALERT_TOKEN = 'searchAlertToken',
  PRICE_DROP_ALERT_ACTION = 'priceDropAlertAction',
  CRIF_MODAL_LAST_DISPLAYED = 'crifModalLastDisplayed',
  FINANCING_MODAL_LAST_DISPLAYED = 'financingModalLastDisplayed',
  RENTAL_CERTIFICATE_MODAL_LAST_DISPLAYED = 'rentalCertificateModalLastDisplayed',
  ACKNOWLEDGE_TENANTPLUS_SERVICE = 'acknowledgedTenantPlusService',
  PDP_OPENED_COUNT = 'pdpOpenedCount',
  SRP_OPENED_COUNT = 'srpOpenedCount',
  BOTTOM_SHEET_OPENED_DATE = 'bottomSheetOpenedDate',
  MORTGAGE_CALCULATOR = 'mortgageCalculatorValues',
  TENANT_PLUS_SUPSCRIPTION_CACHE = 'tenantPlusSubscriptionCache',
  USER_PROFILE_ID = 'userProfileId',
  REDIRECT_STATE = 'redirectState',
  LEGAL_PROTECTION_MODAL_LAST_DISPLAYED = 'legalProtectionModalLastDisplayed',
  ENTRY_POINT = 'entryPoint',
}
